<template>
  <div class="yxtbiz-hour-record-audit" v-loading="loading">
    <div class="title font-size-16 font-bolder lh28">
      <div class="ellipsis">{{ info.trainName }}</div>
      <!-- <yxt-tag
        size="small"
        :type="
          ['default', 'danger', 'warning', 'danger', 'success'][
            info.auditStatus
          ]
        "
        >{{
          ['未提交', '已撤销', '待审核', '已拒绝', '已通过'][info.auditStatus]
        }}</yxt-tag
      > -->
    </div>
    <yxt-row>
      <yxt-col :span="8" class="mt15">
        培训类别：{{ ['线上', '线下'][info.trainType] }}
      </yxt-col>
      <yxt-col :span="12" class="mt15">
        学时：{{ info.trainHour }}学时
      </yxt-col>
      <yxt-col :span="24" class="mt15">
        地点：{{ info.trainAddress || '-' }}
      </yxt-col>
      <yxt-col :span="24" class="mt15">
        培训时间：{{
          info.startDate
            ? dayjs(info.startDate).format('YYYY-MM-DD HH:mm')
            : '-'
        }}
        至
        {{
          info.endDate ? dayjs(info.endDate).format('YYYY-MM-DD HH:mm') : '-'
        }}
      </yxt-col>
    </yxt-row>
    <div class="file-list">
      <div
        class="file-list-item mr20 br8"
        v-for="(item, index) in imgFileList"
        :key="index"
      >
        <div class="mt15 img-content bg-gray-2">
          <yxt-svg
            v-if="item.fileType && item.fileSuffix !== 'img'"
            :icon-class="formatIconName(item)"
            :remote-url="iconUrl"
            width="50"
            class="ml25"
          />
          <img v-else class="img-upload" :src="item.fileUrl" />
          <div class="mark">
            <i class="yxt-icon-view hand" @click="toPreview(item)"></i>
            <i class="yxt-icon-download ml30 hand" @click="toDown(item)"></i>
          </div>
        </div>
        <yxt-tooltip
          :open-filter="true"
          :content="item.fileName"
          placement="top"
        >
          <div class="mt10 file-name ellipsis">
            {{ item.fileName }}
          </div></yxt-tooltip
        >
      </div>
      <yxtbiz-image-viewer
        :ref="`imageViewer`"
        :data="
          info.imgFileList.map(item => {
            return {
              url: item.fileUrl
            };
          })
        "
        :showNavbar="false"
        no-list
        :showToolbar="true"
      ></yxtbiz-image-viewer>
    </div>
  </div>
</template>

<script>
import { TrainingInfo, getDownloadExcelUrl } from './service';
import dayjs from 'dayjs';
import ImageViewer from '../../image-viewer';
export default {
  name: 'YxtbizHourRecordAudit',
  components: {
    [ImageViewer.name]: ImageViewer
  },
  props: {
    id: { type: String }
  },
  data() {
    return {
      dayjs,
      info: {
        imgFileList: [],
        fileList: []
      },
      loading: false,
      imgFileList: [],
      iconUrl:
        window.feConfig.common.staticBaseUrl + 'ufd/3f5568/common/h5/svg/'
    };
  },
  created() {
    this.loading = true;
    TrainingInfo(this.id)
      .then(res => {
        this.info = res.data;
        this.info.imgFileList &&
          this.imgFileList.push(...this.info.imgFileList);
        this.info.fileList && this.imgFileList.push(...this.info.fileList);
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  },
  methods: {
    formatIconName(val) {
      return val.fileSuffix ? 'kng-' + val.fileSuffix : 'kng-kng';
    },
    toDown(row) {
      if (row.fileType) {
        getDownloadExcelUrl(row.fileId).then(res => {
          window.open(res.downloadUrl, '_blank');
        });
      } else {
        window.open(row.fileUrl, '_blank');
      }
    },
    toPreview(row) {
      if (
        row.fileType &&
        row.fileSuffix !== 'img' &&
        ['word', 'pdf', 'excel', 'ppt', 'video', 'audio'].includes(
          row.fileSuffix
        )
      ) {
        let type = 1;
        switch (row.fileSuffix) {
          case 'img':
            type = 0;
            break;
          case 'video':
            type = 2;
            break;
          case 'audio':
            type = 3;
            break;
          default:
            type = 1;
            break;
        }
        window.open(
          window.location.origin +
            '/mix2/dasheng/#/hour-record/preview' +
            `?fileId=${row.fileId}&type=${type}&fileName=${row.fileName}`
        );
      } else if (!row.fileType || row.fileSuffix === 'img') {
        const imgArr = this.info.imgFileList.map(item => {
          return item.fileId;
        });
        imgArr.indexOf(row.fileId) > -1 &&
          this.$refs['imageViewer'].view(imgArr.indexOf(row.fileId));
      } else {
        this.$message({
          type: 'warning',
          message: '此文件格式不支持预览'
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.file-list {
  display: inline-block;
}
.file-list-item {
  display: inline-block;
  width: 100px;
}
.img-content {
  width: 100px;
  height: 100px;
  position: relative;
  .img-upload {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  &:hover {
    .mark {
      visibility: visible !important;
    }
  }
}

.mark {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  visibility: hidden;
  border-radius: 8px;
  background: rgba(
    $color: (
      #000000
    ),
    $alpha: 0.5
  );
}
.br8 {
  border-radius: 8px;
}
</style>
